import Vue from "vue";
import Component from "vue-class-component";
import $ from "jquery";
import moment from "moment";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { DsnDeclarationDetailleeDto } from "../../../dto/GenApi.iNotPaie.Dto/DsnDeclarationDetailleeDto";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";
import { DsnNatureDeclaration } from "../../../dto/GenApi.iNotPaie.Dto/DsnNatureDeclaration";

interface keyValue {
	key: string,
	value: string
}

@Component
export default class ModalVisualisationDetailsDsnComponent extends Vue {
	public dataReady = false;
	public displayFilter = false;
	public dsnDeclarationDetaillee?: DsnDeclarationDetailleeDto;
	public filteredList?: DsnDeclarationDetailleeDto;
	public blockList: keyValue[] = [];
	public blockSelected = "";

	public Init(idDsnMetadata: number): void {
		this.blockSelected = "";
		ServicesFactoryInstance.DsnService.GetDsnDeclarationDetaillee(idDsnMetadata, data => {
			this.dsnDeclarationDetaillee = data;
			this.filteredList = { ...this.dsnDeclarationDetaillee };
			this.fetchData();
		});
	}

	private fetchData(): void {
		this.blockList = this.dsnDeclarationDetaillee!.ListeDsnBlocs.map(block => block.LibelleBloc!).filter(function(item, pos, self) {
			return self.indexOf(item) === pos;
		}).map((block) => ({
			key: block,
			value: block
		}));

		this.dataReady = true;
	}

	public modify(): void {
		if (this.filteredList !== undefined) {
			if (this.blockSelected !== "") {
				this.filteredList.ListeDsnBlocs = this.dsnDeclarationDetaillee!.ListeDsnBlocs.filter(block => block.LibelleBloc === this.blockSelected);
			} else {
				this.filteredList.ListeDsnBlocs = this.dsnDeclarationDetaillee!.ListeDsnBlocs;
			}
		}
	}

	public cancel(): void {
		$("#modalVisualisationDetailsDsnComponent").modal("hide");
	}

	public editionDSN(isExcel: boolean): void {
		NotificationServiceInstance.SendSuccess("La demande d'édition a été prise en compte. Le document sera bientôt disponible");

		ServicesFactoryInstance.EditionsService.getEditionListeDSN(this.filteredList!, isExcel, (r: Blob) => {
			let libelle = "dsn-" + this.dsnDeclarationDetaillee?.DsnMetadata.Mois + "-" + this.dsnDeclarationDetaillee?.DsnMetadata.Annee + ".";
			libelle += (isExcel) ? "xlsx" : "pdf";

			if (window.navigator && window.navigator.msSaveOrOpenBlob) {
				window.navigator.msSaveOrOpenBlob(r, libelle);
			} else {
				const link = document.createElement("a");
				document.body.appendChild(link);

				link.href = window.URL.createObjectURL(r);
				link.download = libelle;
				link.click();

				NotificationServiceInstance.SendSuccess("L'édition de la liste des salariés s'est correctement déroulée !");
			}
		});
	}

	public getPeriod(): string {
		return moment.utc(this.dsnDeclarationDetaillee!.DsnMetadata.DateCreation).format("DD/MM/YYYY");
	}

	public getTitle(avecNomSalarie: boolean): string {
		if (!this.dsnDeclarationDetaillee?.DsnMetadata?.NatureDeclaration) {
			return "";
		}

		let titreFenetre = "";
		switch (this.dsnDeclarationDetaillee!.DsnMetadata.NatureDeclaration) {
			case DsnNatureDeclaration.ARRET:
				titreFenetre = "Arrêt de travail";
				break;
			case DsnNatureDeclaration.FINCONTRATUNIQUE:
				titreFenetre = "Fin de contrat de travail";
				break;
			case DsnNatureDeclaration.AMORCAGETAUXPAS:
				titreFenetre = "Amorçage";
				break;
			default:
				titreFenetre = "Mensuelle"; // case Mensuelle
				break;
		}

		if (!avecNomSalarie) {
			return titreFenetre;
		}

		const nomSalarie = this.dsnDeclarationDetaillee?.DsnMetadata?.NomSalarie || "";
		const prenomSalarie = this.dsnDeclarationDetaillee?.DsnMetadata?.PrenomSalarie || "";

		let detailSalarie = (nomSalarie || prenomSalarie) ? `${nomSalarie} ${prenomSalarie}` : "";
		detailSalarie = detailSalarie ? ` - ${detailSalarie}` : "";

		titreFenetre += detailSalarie;

		return titreFenetre;
	}

	public switchFilter(): void {
		this.displayFilter = !this.displayFilter;
	}

	public getName(fullName: string): string {
		return fullName.substr(fullName.indexOf(" ") + 1);
	}
}



// WEBPACK FOOTER //
// ./src/components/dsn/modalVisualisationDetailsDsn/modalVisualisationDetailsDsn.ts